import { updateLinksAttributes } from '../utils/handleAttributes';

export default function photoGallery() {
  const widgetName = 'photoGallery';
  const widgetOpts = photoGalleryOpts;

  const $widget = $(`#${widgetName}`);

  const linkedImages = true;

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: linkedImages ? ['all'] : [''],
    hasImages: true,
    textOverImage: false,
    lazyLoadImages: true,
    imageIsBackground: false,
    maxItemsVisible: 4,
    itemsPerPanel: 1,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        $widget.find('.card-content').remove();
        changeFormatCards(data.items);
      }
    },
  });

  function changeFormatCards(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { URL, Title } = widgetData[x];
      const $card = $(this);

      updateLinksAttributes(URL, Title, $card);

      if (linkedImages) {
        $card.addClass('linked-images');
      }
    });
  }
}
